import {
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  styled,
  Accordion,
  Button as MuiButton,
  Theme,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core';
import { Button } from 'src/modules/shared/components';

export const StudyCardContainer = styled('div')<Theme>(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const StudyCardContent = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0%',
  overflow: 'auto',
}));

export const StudyCardNewFooter = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',

  width: '100%',
}));

export const FooterContainer = styled('div')<Theme>(({ theme }) => ({
  height: '64px',
  width: '100%',
  borderTop: `4px solid ${theme.palette.studyCard.grey}`,
  background: 'white',
  padding: '14px 32px 14px 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
}));

export const StartButton = Button;

export const FormContainer = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const RadioGroupLabel = styled(FormLabel)({
  fontWeight: 'bold',
  color: 'black',
  marginBottom: '1rem',
  display: 'flex',
  alignItems: 'center',
});

export const CheckboxContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  gap: '5px',
  marginTop: '3rem',
});

export const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItem: 'center',
  marginTop: '3rem',
});

export const HeaderContainer = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const StopButtonWrapper = styled('div')({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const StopButton = styled(MuiButton)({
  fontWeight: 'bold',
});

export const TrajectoryTitle = styled('h1')<Theme>(({ theme }) => ({
  lineHeight: '40px',
  fontSize: theme.typography.h1.fontSize,
  fontWeight: 'bold',
  textAlign: 'left',
  marginBottom: 0,
  marginTop: 0,
}));

export const TrajectorySubtitle = styled('h2')<Theme>(({ theme }) => ({
  lineHeight: '24px',
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 'normal',
  textAlign: 'left',
  color: theme.palette.grey[900],
  marginTop: 0,
}));

export const CardsListContainer = styled('div')({
  width: 'auto',
  height: 'auto',
});

export const CardListAccordion = styled(Accordion)({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  width: '100%',
});

export const CardListAccordionDetails = styled(AccordionDetails)({
  backgroundColor: 'transparent',
  border: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '&.Mui-expanded': {
    marginTop: 0,
  },
});

export const StyledUploadLink = styled(Typography)<Theme>(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 900,
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

export const CardListAccordionSummary = styled(AccordionSummary)<Theme>(({ theme }) => ({
  backgroundColor: 'transparent',
  padding: 0,
  margin: 0,
  border: 'none',
  '&:before': {
    'background-color': theme.palette.grey['100'],
  },
  '&.Mui-expanded': {
    marginTop: 0,
  },
  '@media print': {
    display: 'none',
  },
}));

export const CardListTitle = styled('h3')<Theme>(({ theme }) => ({
  lineHeight: '24px',
  fontSize: theme.typography.h3.fontSize,
  fontWeight: 'bold',
  textAlign: 'left',
  marginBottom: 0,
}));

export const CardListTitleSubtitle = styled('h4')<Theme>(({ theme }) => ({
  lineHeight: '24px',
  fontSize: theme.typography.h4.fontSize,
  fontWeight: 'normal',
  textAlign: 'left',
  color: theme.palette.grey[900],
  marginTop: 0,
}));

export const CardContainer = styled('div')<Theme>(({ theme }) => ({
  width: '100%',
  height: '167px',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.studyCard.grey}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: 'white',
}));

export const CardContent = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(1),
  fontWeight: 'bold',
  overflow: 'hidden',
  height: 'calc(100% - 30px)',
  cursor: 'pointer',
  '& .fr-view': {
    '& p': {
      margin: 0,
    },
  },
}));

export const CardFooter = styled('div')<Theme>(({ theme }) => ({
  width: '100%',
  height: '30px',
  backgroundColor: theme.config.appbarColors.background,
  borderBottomRightRadius: theme.shape.borderRadius,
  borderBottomLeftRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'row',
}));

export const CardFooterLeftContent = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
  paddingLeft: '1rem',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  gap: '1.5rem',
  '& > div': {
    fontSize: '14px',
    lineHeight: '16px',
    '& > span': {
      marginLeft: '0.5rem',
    },
  },
});

export const ReorderHandler = styled('div')<Theme>(({ theme }) => ({
  height: '80%',
  width: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.white,
  borderRadius: '3px',
  border: `1px solid ${theme.palette.studyCard.grey}`,
  cursor: 'pointer',
}));

export const CardFooterRightContent = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  height: '100%',
  width: '50%',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexDirection: 'row',
  marginRight: '1rem',
  '& .is-known': {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: theme.palette.studyCard.green,
  },
}));

export const TrainingSessionContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 'calc(100% - 64px)',
});

export const StudyCardLarge = styled('div')<
  Theme,
  { frontside?: boolean; flipCard?: boolean; hasExplanation?: boolean }
>(({ theme, frontside, flipCard, hasExplanation }) => ({
  height: '300px',
  width: '620px',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderTopRightRadius: flipCard ? theme.config.defaultBorderRadius : '12px',
  borderTopLeftRadius: flipCard ? theme.config.defaultBorderRadius : '12px',
  borderBottomLeftRadius: !frontside && hasExplanation ? theme.config.defaultBorderRadius : '12px',
  borderBottomRightRadius: !frontside && hasExplanation ? theme.config.defaultBorderRadius : '12px',
  overflowY: 'scroll',
  display: 'flex',
  justifyContent: !flipCard ? 'center' : 'flex-start',
  '& .fr-view': {
    padding: 0,
    display: frontside ? (flipCard ? 'block' : 'flex') : 'block',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  fontWeight: frontside ? (flipCard ? 'normal' : 'bold') : 'normal',
  '&::-webkit-scrollbar': {
    width: '0.25em', // Set a width to trigger scrollbar visibility (you can adjust this value)
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'silver', // Transparent background makes the scrollbar thumb invisible
    borderRadius: '12px',
  },
}));

export const StudyCardLargeWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
  width: '620px',
  '& .study-card-large-top-content': {
    width: '620px',
    height: '64px',
    '& .fr-view': {
      textAlign: 'center',
    },
    backgroundColor: theme.palette.common.white,
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    fontWeight: 'bold',
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    padding: theme.spacing(2),
  },
}));

export const StudyCardLargeFooter = styled(Accordion)({
  backgroundColor: '#F3F1EC',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
  width: '100%',
  left: 0,
  padding: 0,
  margin: 0,
  fontWeight: 'normal',
  '&.Mui-expanded': {
    marginTop: 0,
    backgroundColor: 'white',
    boxShadow: 'none',
    border: 'none',
  },
});

export const StudyCardLargeAccordionSummary = styled(AccordionSummary)<Theme>(({ theme }) => ({
  backgroundColor: 'transparent',
  padding: 0,
  margin: 0,
  marginLeft: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  height: '64px',
  '&.Mui-expanded': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    padding: theme.spacing(2),
    marginLeft: 0,
    '& .show-more': {
      color: 'transparent',
      flex: 1,
    },
    '& div': {
      color: theme.palette.common.black,
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    zIndex: 0,
  },
  '@media print': {
    display: 'none',
  },
}));

export const StudyCardLargeAccordionDetails = styled(AccordionDetails)<Theme>(({ theme }) => ({
  backgroundColor: 'white',
  padding: theme.spacing(0),
  paddingLeft: theme.spacing(2),
  height: '64px',
  maxHeight: '200px',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'scroll',
  borderBottomRightRadius: '12px',
  borderBottomLeftRadius: '12px',
  borderRadius: '12px',
  borderTop: `${theme.config.defaultBorder(theme.palette.grey[100])}`,
  '-webkit-box-shadow': '0 -8px 9px -5px rgba(0,0,0,0.26)',
  '-moz-box-shadow': '0 -8px 9px -5px rgba(0,0,0,0.26)',
  'box-shadow': '0 -8px 9px -5px rgba(0,0,0,0.26)',

  '&.MuiAccordionDetails-root': {
    height: '200px',
    marginTop: '-264px',
    zIndex: 999,
  },
  '& .fr-view': {
    textAlign: 'left',
    width: '100%',
  },
  '&::-webkit-scrollbar': {
    width: '0.5em',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.grey.A100,
  },
}));

export const StudyCardLargeSideIndicator = styled('div')<Theme, { frontside?: boolean }>(
  ({ theme, frontside }) => ({
    backgroundColor: !frontside ? theme.palette.primary.main : 'transparent',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.main}`,
    marginTop: '0.5rem',
  })
);

export const StudyCardLargeScoreIndicatorContainer = styled('div')({
  width: '8px',
  height: '8px',
});

export const ScoreIndicatorsWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  gap: '0.67rem',
  flexDirection: 'row',
  marginTop: theme.spacing(4),
}));

export const TryLaterButton = styled(MuiButton)<Theme>(({ theme }) => ({
  backgroundColor: theme.palette.studyCard.accessibleBlue,
  color: theme.palette.common.white,
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  '&:hover': {
    backgroundColor: theme.palette.studyCard.accessibleBlue,
  },
}));

export const CorrectButton = styled(MuiButton)<Theme>(({ theme }) => ({
  backgroundColor: theme.palette.studyCard.green,
  color: theme.palette.common.white,
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  '&:hover': {
    backgroundColor: theme.palette.studyCard.green,
  },
}));

export const ScoreDialogContainer = styled(DialogContent)({
  width: '500px',
  height: '350px',
  '& > .MuiGrid-root': {
    display: 'flex',
    gap: '2rem',
    marginTop: '1rem',
    '& > .MuiGrid-item': {
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      lineHeight: '16px',
      '& > div > span': {
        display: 'flex',
        gap: '0.5rem',
      },
    },
  },
});

export const ScoreDialogTitle = styled(DialogTitle)({
  backgroundColor: '#F3F1EC',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  '& > span': {
    display: 'flCardPreviewContainerex',
    lineHeight: '20px',
    gap: '1rem',
  },
});

export const CardPreviewContainer = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  width: '620px',
  borderRadius: '12px',
  backgroundColor: theme.palette.background.paper,
  '& .card-question': {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& .fr-view': {
      fontWeight: 'bold',
    },
  },
  '& .card-answer': {
    overflow: 'hidden',

    padding: theme.spacing(2),
    '& .fr-view': {
      fontWeight: 'normal',
      '& p': {
        margin: 0,
      },
    },
  },
}));

export const CardPreviewContent = styled(DialogContent)<Theme>(({ theme }) => ({
  //width: '700px',
  height: 'auto',
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
}));

export const ModalContentWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
}));

export const DialogDivider = styled(Divider)<Theme>(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(3),
}));

export const CTAWrapper = styled('div')<Theme>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const NewTrainingButton = styled(MuiButton)<Theme>(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing(1),
  width: 200,
  '&:hover': {
    background: theme.palette.primary.main,
  },
}));

export const PreviewCardContainer = styled('div')({
  fontFamily: 'Open Sans, sans-serif',
  minWidth: '520px',
  borderRadius: '10px',
  perspective: '1400px',
});

export const PreviewCardWrapper = styled('div')({
  position: 'relative',
  height: '100%',
  width: '100%',
  borderRadius: '10px',
  transformStyle: 'preserve-3d',
  transition: 'transform 0.4s ease-in-out',
});

export const Front = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backfaceVisibility: 'hidden',
  backgroundColor: '#fff',
});

export const FrontContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const QuestionContainer = styled('div')({
  display: 'flex',
  fontWeight: 'bold',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 16px',
});

export const AnswerContainer = styled('div')({
  padding: '8px 16px',
});

export const OptionalExplanationContainer = styled(Accordion)<Theme>(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',

  backgroundColor: '#F3F1EC',

  padding: '0px',
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  cursor: 'pointer',
  '& .MuiCollapse-root.MuiCollapse-entered': {
    display: 'flex',
    width: '100%',
  },
}));

export const Back = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backfaceVisibility: 'hidden',
  backgroundColor: '#fff',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'rotateY(180deg)',
  cursor: 'pointer',
});

export const BackCardContent = styled('div')({
  width: '100%',
  height: '100%',
  '& > div:first-of-type': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
});
